/**
 * RelationshipTypePicker — seletor single-select dos 39 tipos de relacionamento
 * agrupados por área (Família, Tutela legal, …). Diferente do ScopePicker do B1
 * (multi-select de escopos), aqui o vínculo factual é UM tipo só — `<select>`
 * com `<optgroup>` é a forma acessível e enxuta. Reutilizado por adicionar/editar.
 */

import { RELATIONSHIP_GROUPS, relationshipLabel } from './related-persons-labels';

interface RelationshipTypePickerProps {
  value: string;
  onChange: (type: string) => void;
  id: string;
}

export function RelationshipTypePicker({
  value,
  onChange,
  id,
}: RelationshipTypePickerProps): JSX.Element {
  return (
    <select
      id={id}
      className="brp-input brp-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">Selecione o tipo…</option>
      {RELATIONSHIP_GROUPS.map((group) => (
        <optgroup key={group.label} label={group.label}>
          {group.types.map((type) => (
            <option key={type} value={type}>
              {relationshipLabel(type)}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
